import HistorialMedicoComponent from "../components/HistorialMedico/HistorialMedico";
export default function HistorialMedico() {
  return <HistorialMedicoComponent />;
}
